import React from 'react';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import hindRegular from '../../theme/fonts/hind-vadodara/hind-vadodara-latin-400-normal.woff2';
import robotoSlab from '../../theme/fonts/roboto-slab/roboto-slab-latin-wght-normal.woff2';

// Same files that _fonts.scss references, so the preload is reused by @font-face.
const FONTS = [hindRegular, robotoSlab];

const FontPreloads = () => (
  <Helmet>
    {FONTS.map((href) => (
      <link
        key={href}
        rel="preload"
        as="font"
        type="font/woff2"
        href={href}
        crossOrigin="anonymous"
      />
    ))}
  </Helmet>
);

export default FontPreloads;
